(()=>{const root=document.querySelector('[data-monthly]'),trigger=root?.querySelector('.pk-monthly-trigger'),panel=root?.querySelector('.pk-monthly-panel'),closeButton=root?.querySelector('.pk-monthly-close');if(!root||!trigger||!panel||!closeButton)return;document.body.append(panel);function position(){const r=trigger.getBoundingClientRect(),header=trigger.closest('header').getBoundingClientRect(),width=Math.min(414,innerWidth-32);panel.style.setProperty('--monthly-width',width+'px');panel.style.setProperty('--monthly-left',Math.min(Math.max(16,r.right-width),innerWidth-width-16)+'px');panel.style.setProperty('--monthly-top',Math.min(header.bottom+9,innerHeight-220)+'px')}function close(focus=false){panel.hidden=true;trigger.setAttribute('aria-expanded','false');if(focus)trigger.focus()}trigger.addEventListener('click',()=>{if(!panel.hidden){close();return}position();panel.hidden=false;trigger.setAttribute('aria-expanded','true');closeButton.focus({preventScroll:true})});closeButton.addEventListener('click',()=>close(true));document.addEventListener('click',e=>{if(!panel.hidden&&!root.contains(e.target)&&!panel.contains(e.target))close()});document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!panel.hidden){e.preventDefault();close(true)}});document.addEventListener('focusin',e=>{if(!panel.hidden&&!root.contains(e.target)&&!panel.contains(e.target))close()});addEventListener('resize',()=>{if(!panel.hidden)position()});addEventListener('scroll',()=>{if(!panel.hidden)close()},{passive:true});})();

// Render the existing editions in a page dialog; never navigate to a PDF URL.
(() => {
  const reader = document.querySelector('[data-monthly-reader]');
  const panel = document.querySelector('.pk-monthly-panel');
  const trigger = document.querySelector('.pk-monthly-trigger');
  if (!reader || !panel || !trigger) return;
  document.body.append(reader);
  const body = reader.querySelector('.pk-monthly-reader__body');
  const pages = reader.querySelector('.pk-monthly-reader__pages');
  const title = reader.querySelector('h2');
  const status = reader.querySelector('[role="status"]');
  const retry = reader.querySelector('[data-monthly-retry]');
  const zoom = reader.querySelector('[data-monthly-zoom]');
  const closeButton = reader.querySelector('[data-monthly-reader-close]');
  let libraryPromise, loadingTask, pdf, observer, opener, oldOverflow = '', generation = 0;
  let queue = Promise.resolve();
  const tasks = new Set();
  function library() {
    if (!libraryPromise) {
      libraryPromise = import(reader.dataset.pdfLibrary).then(lib => {
        lib.GlobalWorkerOptions.workerSrc = reader.dataset.pdfWorker;
        return lib;
      }).catch(error => { libraryPromise = null; throw error; });
    }
    return libraryPromise;
  }
  function cancelPages() {
    generation += 1;
    if (observer) observer.disconnect();
    for (const task of tasks) task.cancel();
    tasks.clear();
    queue = Promise.resolve();
  }
  function destroyDocument() {
    cancelPages();
    const oldTask = loadingTask;
    loadingTask = null;
    pdf = null;
    if (oldTask) oldTask.destroy().catch(() => {});
    pages.replaceChildren();
  }
  function showError(error) {
    if (error) console.warn("Potala monthly reader:", error.message);
    status.textContent = 'This edition could not be displayed. Please try again.';
    status.hidden = false;
    retry.hidden = false;
  }
  function buildPages(preservePosition = false) {
    if (!pdf || !reader.open) return;
    const progress = preservePosition && pages.scrollHeight ? body.scrollTop / pages.scrollHeight : 0;
    cancelPages();
    pages.replaceChildren();
    const doc = pdf, stamp = generation;
    const available = Math.max(220, body.clientWidth - parseFloat(getComputedStyle(body).paddingLeft) - parseFloat(getComputedStyle(body).paddingRight));
    const width = Math.min(900, available) * Number(zoom.value);
    pages.style.setProperty('--monthly-reading-width', width + 'px');
    body.scrollTop = 0;
    body.scrollLeft = 0;
    async function paint(state) {
      if (state.done || stamp !== generation || !reader.open) return;
      const page = await doc.getPage(state.number);
      if (stamp !== generation) return;
      const natural = page.getViewport({ scale: 1 });
      const ratio = Math.min(devicePixelRatio || 1, 1.5, Math.sqrt(1400000 / (width * width * natural.height / natural.width)));
      const viewport = page.getViewport({ scale: width / natural.width * ratio });
      state.canvas.width = Math.ceil(viewport.width);
      state.canvas.height = Math.ceil(viewport.height);
      const task = page.render({ canvasContext: state.canvas.getContext('2d', { alpha: false }), viewport });
      tasks.add(task);
      try {
        await task.promise;
        if (stamp !== generation) return;
        state.done = true;
        state.article.dataset.rendered = 'true';
        if (state.number === 1) status.hidden = true;
        page.getTextContent().then(text => {
          if (stamp === generation) state.text.textContent = text.items.map(item => item.str || '').join(' ');
        }).catch(() => {});
      } finally { tasks.delete(task); }
    }
    function enqueue(state) {
      if (state.queued || state.done) return;
      state.queued = true;
      queue = queue.then(() => paint(state)).catch(error => {
        if (stamp === generation && error.name !== 'RenderingCancelledException') showError(error);
      });
    }
    const states = [];
    for (let number = 1; number <= doc.numPages; number += 1) {
      const article = document.createElement('article');
      article.className = 'pk-monthly-reader__page';
      article.dataset.page = String(number);
      const label = document.createElement('p');
      label.className = 'pk-monthly-reader__page-label';
      label.textContent = number + ' / ' + doc.numPages;
      const canvas = document.createElement('canvas');
      canvas.className = 'pk-monthly-reader__canvas';
      canvas.width = 1; canvas.height = 1;
      canvas.style.height = width * 841.89 / 595.28 + 'px';
      canvas.setAttribute('role', 'img');
      canvas.setAttribute('aria-label', 'Magazine page ' + number + ' of ' + doc.numPages);
      const text = document.createElement('div');
      text.className = 'pk-monthly-reader__text';
      text.lang = 'en';
      article.append(canvas, label, text);
      pages.append(article);
      states.push({ number, article, canvas, text, done: false, queued: false });
    }
    observer = new IntersectionObserver(entries => {
      for (const entry of entries) if (entry.isIntersecting) enqueue(states[Number(entry.target.dataset.page) - 1]);
    }, { root: body, rootMargin: '400px 0px' });
    for (const state of states) observer.observe(state.article);
    body.scrollTop = progress * pages.scrollHeight;
    if (!preservePosition) enqueue(states[0]);
  }
  async function openEdition(link) {
    if (!reader.open) {
      opener = link;
      oldOverflow = document.documentElement.style.overflow;
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      reader.showModal();
      document.documentElement.style.overflow = 'hidden';
    }
    destroyDocument();
    const stamp = generation;
    title.textContent = link.querySelector('.pk-monthly-translation')?.textContent || link.querySelector('h3').textContent;
    status.textContent = 'Loading edition…'; status.hidden = false; retry.hidden = true;
    zoom.value = '1'; closeButton.focus({ preventScroll: true });
    try {
      const url = new URL(link.dataset.monthlyPdf);
      if (url.protocol !== 'https:' || url.hostname !== 'cdn.shopify.com') throw new Error('Invalid edition source');
      const lib = await library();
      if (stamp !== generation || !reader.open) return;
      loadingTask = lib.getDocument({ url: url.href, isEvalSupported: false, useWasm: false });
      const documentProxy = await loadingTask.promise;
      if (stamp !== generation || !reader.open) { documentProxy.destroy(); return; }
      pdf = documentProxy;
      reader.dataset.pageCount = String(pdf.numPages);
      buildPages();
    } catch (error) {
      if (stamp === generation && reader.open) showError(error);
    }
  }
  panel.addEventListener('click', event => {
    const link = event.target.closest('[data-monthly-pdf]');
    if (!link) return;
    event.preventDefault();
    openEdition(link);
  });
  closeButton.addEventListener('click', () => reader.close());
  reader.addEventListener('click', event => { if (event.target === reader) reader.close(); });
  reader.addEventListener('close', () => {
    destroyDocument();
    document.documentElement.style.overflow = oldOverflow;
    trigger.focus({ preventScroll: true });
  });
  retry.addEventListener('click', () => { if (opener) openEdition(opener); });
  zoom.addEventListener('change', () => buildPages(true));
  let resizeTimer;
  addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => { if (reader.open && pdf) buildPages(true); }, 180);
  });
})();

